import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IPricingApi } from "@/api/pricing";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { MetaRatePayload } from "@/models/pricing";
import { useToast } from "@/hooks/use-toast";
import { invalidatePricing } from "./invalidatePricing";

export const useUpsertMetaRate = () => {
  const pricingApi = useInjection<IPricingApi>(SERVICES_TYPES.PRICING);
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (payload: MetaRatePayload) => pricingApi.upsertRate(payload),
    onSuccess: () => {
      invalidatePricing(queryClient);
      toast({ title: "Rate saved" });
    },
    onError: (error) => {
      toast({ title: "Failed to save rate", description: error.message, variant: "destructive" });
    }
  });
};
